const Spacer = ({ size = 10 }) => {
  return <div style={{ width: size, height: size }} />;
};

export default Spacer;
